import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {CustomerService} from '../../../core/services/customer.service';
import {Company} from '../../model/company.model';
import {INewCompany} from '../../model/interface/new-company.model.interface';
import {LegalEntityType} from '../../model/legal-entity.model';

@Component({
  selector: 'app-add-company',
  templateUrl: './add-company.component.html',
  styleUrls: ['./add-company.component.css']
})
export class AddCompanyComponent implements OnInit {
  requiredContact = false;
  instructing: number;
  companyType: 'LEGAL_ENTITY' | 'NATURAL_PERSON';

  constructor(private dialogRef: MatDialogRef<AddCompanyComponent>,
              private customerService: CustomerService,
              @Inject(MAT_DIALOG_DATA) data) {
    this.requiredContact = data?.requiredContact ?? false;
    this.instructing = typeof data === 'number' ? data : data?.lessorId;
    this.companyType = typeof data === 'object' ? data?.companyType : undefined;
  }

  ngOnInit(): void {
  }

  add(formValue) {

    const mainAddress = formValue.mainAddress;
    const correspondenceAddress = formValue.correspondenceAddress;

    const addresses = [];

    if (mainAddress) {
      mainAddress.typeId = 1;
      addresses.push(mainAddress)
    }

    if (correspondenceAddress?.city) {
      correspondenceAddress.typeId = 2;
      addresses.push(correspondenceAddress)
    }

    const newCompany: INewCompany = {
      companyName: formValue.companyName,
      nip: formValue.nip,
      type: LegalEntityType.COMPANY,
      regon: formValue.regon,
      addresses: addresses,
      individualNumber: formValue.individualNumber
      , companyType: this.companyType
    };

    return this.customerService.createCompany(newCompany, this.instructing).subscribe(
      (createdCompany) => {
        this.close(createdCompany);
      }
    );
  }

  cancel() {
    this.close(null);
  }

  useExistingCompany(company: Company) {
    this.close(company);
  }

  private close(value: Company | null) {
    this.dialogRef.close(value);
  }

}
